<template>
  <v-container fluid style="height: 100%">
    <v-col>
      <v-row>
        <span> <b>{{ $t('EMAIL') }}</b> </span>
      </v-row>
      <v-text-field
        ref="formEmail"
        v-model="providerContact"
        :rules="rules.email"
        :disabled="true"
        name="email"
        type="text"
        @blur="updateInvoice()"
      />
      <div v-if="!providerContact" align="center" style="margin-bottom: 15px; font-size: 13px; color: #FF6961">
        {{ $t('You must enter the email of the ') }}
        <span v-if="imThePayer()">{{ $t('receiver!') }}</span>
        <span v-else>{{ $t('payer!') }}</span>
      </div>
      <v-row justify="center">
        <span>{{ $t("payProvider", {invoicePrice: invoice.amount}) }}</span>
      </v-row>
      <ListInvoices v-if="!loading" :sent="sent" :original-invoice="invoice" :byppay="byppayIdent" />
      <v-row justify="center">
        <v-btn x-large style="margin-top: 15px" @click="$router.go(-1)">
          {{ $t("Back") }}
        </v-btn>
      </v-row>
    </v-col>
    <InvoiceMissingInformation v-if="!loading" :invoice="invoice" :file="file.originalName" :forward="false" @update="fetch" />
  </v-container>
</template>

<script>
import ListInvoices from "../components/ListInvoices";
import ApiRepository from "../repositories/ApiRepository";
import InvoiceMissingInformation from "../components/InvoiceMissingInformation";
import Constants from "../../constants";

export default {
    name: "Bypay",
    components: {ListInvoices, InvoiceMissingInformation},
    data () {
        return {
            loading: true,
            file: null,
            providerContact: '',
            byppayIdent: Constants.BYPPAY_IDENTIFIER,
            sent: true,
            invoice: {
                amount: 0
            },
            rules: {
                email: [
                    v => !!v || this.$t('Error.The mail field is required'),
                    v => /.+@.+\..+/.test(v) || this.$t('The mail must be valid.')],
            },
            mailTo: ""
        };
    },
    created () {
        this.fetch();
    },
    methods: {
        fetch () {
            if (this.$route.params.id) {
                this.$root.$emit('start-loading');
                this.loading = true;
                ApiRepository.getInvoiceById(this.$route.params.id)
                    .then((res) => {
                        if (res.data.invoice) {
                            this.invoice = res.data.invoice;
                            this.file = res.data.files[0];
                            this.sent = typeof this.invoice.receiver === "undefined" || this.invoice.receiver._id.toString() !== this.$user._id.toString();
                            let client;
                            if (this.sent) {
                                client = this.invoice.receiver;
                            } else {
                                client = this.invoice.payer;
                            }
                            if (client && client.email) {
                                this.disable = true;
                                this.providerContact = client.email;
                            }
                        }
                    }).finally(() => {
                        this.$root.$emit('stop-loading');
                        this.loading = false;
                    });
            }
        },
        addInvoice () {
            this.$router.push({name: 'imageInvoice', replace: true});
        },
        updateInvoice () {
            let idUser;
            this.invoice.payerCif === this.$user.cif ? idUser = this.invoice.receiverCif : idUser = this.invoice.payerCif;
            ApiRepository.updateEmailUser(idUser, this.providerContact)
                .then(() => {
                    this.$forceUpdate();
                })
                .catch((err) => {
                    console.log("Error: "); console.log(err);

                    let message = this.$t('ERROR: Something went wrong');
                    console.log(err.response.data);
                    if (err.response.data.errorCode === Constants.ERRORS.ERROR_SAME_MAIL) {
                        message = this.$t('Already exists a user with this Email');
                    }
                    this.$root.$emit('show-snackbar', {
                        message: message,
                        color: 'error'
                    });
                });
        },
        imThePayer () {
            return this.invoice.payerCif === this.$user.cif;
        },
    }
};
</script>

<style scoped>
    .full-width{
        width: 100%;
    }
</style>
